export default [
    {
        name:"dashboard",
        label:"Dashboard",
        icon:"la la-dashboard",
        link:"/app/dashboard",
        children:[
            {
                name:"admin_dashboard",
                label:"Admin Dashboard",
                icon:"",
                link:"/app/dashboard"
            },
            {
                name:"dashboard_employee",
                label:"Employee Dashboard",
                icon:"",
                link:"/app/dashboard_employee"
            }
        ]
    },
    {
        name:"clients",
        label:"Clients",
        icon:"la la-users",
        link:"/app/clients",
        roles:['ADMIN'],
        children:[]
    },
    {
        name:"lenders",
        label:"Lenders",
        icon:"la la-user-secret",
        link:"/app/lenders",
        roles:['ADMIN'],
        children:[]
    },
    {
        name:"employees",
        label:"Employees",
        icon:"la la-user-secret",
        link:"/app/employees",
        roles:['ADMIN'],
        children:[]
    },
    {
        name:"leads",
        label:"Leads",
        icon:"la la-user-secret",
        link:"/app/leads",
        roles:['ADMIN'],
        children:[]
    },
    {
        name:"profile",
        label:"Profile",
        icon:"la la-user-secret",
        link:"/app/profile",
        roles:['CLIENT'],
        children:[]
    },
    {
        name:"credit_list",
        label:"Credit Info",
        icon:"la la-user-secret",
        link:"/app/credit_list",
        roles:['ADMIN','CLIENT'],
        rule:(user,props)=>!!props.mixin.companyType.bind({props})(),
        children:[]
    },
    {
        name:"onboarding",
        label:"Onboarding",
        icon:"la la-user-secret",
        link:"/app/onboarding",
        roles:['CLIENT'],
        children:[]
    }
]